/**
 * Tipos del subsistema de audio.
 * Ver docs/SPEC-IMPLEMENTACION.md §3 (BandasAudio).
 */

export interface BandasAudio {
  /** Promedio de bandas 0–10 (~0–1720 Hz). Rango 0–1. */
  bajo: number;
  /** Promedio de bandas 10–50 (~1720–8600 Hz). Rango 0–1. */
  medio: number;
  /** Promedio de bandas 50–127 (~8600–22050 Hz). Rango 0–1. */
  agudo: number;
  /** Promedio global de todas las bandas. Rango 0–1. */
  global: number;
}

export type SuscriptorBandas = (bandas: BandasAudio) => void;

export const BANDAS_INICIALES: BandasAudio = {
  bajo: 0,
  medio: 0,
  agudo: 0,
  global: 0,
};
